import { useLocation } from 'react-router-dom';

import { endpointDetails } from 'src/app/account/graphOnboarding/routes';
import * as orgRoutes from 'src/app/account/routes';

import { useCurrentPlan } from './currentPlanV2Migration';
import { useCheckPlanTypes } from './useCheckPlanTypes';

/**
 * Helper hook to get the location object for the appropriate cloud onboarding path
 *
 * @param { accountId: string }
 * @returns LocationDescriptorObject
 */
export const useCloudOnboardingRootURL = ({
  accountId = '',
}: {
  accountId: string;
}) => {
  const location = useLocation();
  const currentPlanResult = useCurrentPlan({
    skip: !accountId,
    accountId,
  });
  const { isDedicatedPlan } = useCheckPlanTypes({
    tier: currentPlanResult?.currentPlan?.tier,
    kind: currentPlanResult?.currentPlan?.kind,
  });

  try {
    const link = isDedicatedPlan
      ? orgRoutes.supergraphOnboarding.locationFrom({
          fromRouteConfig: orgRoutes.org,
          location,
        })
      : endpointDetails.locationFrom({
          fromRouteConfig: orgRoutes.org,
          location,
        });
    return link;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }

  return '';
};
